import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { TicketDetailsContent } from './components/TicketDetailsContent';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';

const TicketDetails: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Tickets Details | Starjack Admin</title>
            </Helmet>

            <TicketDetailsContent />
        </>
    );
};

TicketDetails.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
TicketDetails.isProtected = true;
TicketDetails.permissions = [Permission.TICKETS_NAV];

export default TicketDetails;
